import { render } from "./HomeItems.vue?vue&type=template&id=218fd300"
import script from "./HomeItems.vue?vue&type=script&lang=ts"
export * from "./HomeItems.vue?vue&type=script&lang=ts"
script.render = render

export default script